import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
import { focusVisible } from '../../shared/global.styles.js';
var PillComponent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", "px;\n  cursor: pointer;\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", "px;\n  padding: ", "px\n    ", "px;\n  width: fit-content;\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", "px;\n  cursor: pointer;\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", "px;\n  padding: ", "px\n    ", "px;\n  width: fit-content;\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), function (props) {
  var _a, _b;

  return props.active ? (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.blueLight : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.white;
}, function (props) {
  var _a, _b;

  return props.active ? (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlue : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.medium;
}, function (props) {
  var _a;

  return (_a = props.theme.attributes) === null || _a === void 0 ? void 0 : _a.borderRadius.big;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.size.s2;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.weight.medium;
}, function (props) {
  var _a;

  return (_a = props.theme.typography) === null || _a === void 0 ? void 0 : _a.lineHeight.s2;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs2;
}, function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xs2;
}, focusVisible, function (props) {
  var _a, _b;

  return props.active ? (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.blueLight : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.lightest;
}, function (props) {
  var _a;

  return props.active && ((_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlueHover);
}, function (props) {
  var _a, _b;

  return props.active ? (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.blueLighter : (_b = props.theme.palette) === null || _b === void 0 ? void 0 : _b.lighter;
}, function (props) {
  var _a;

  return props.active && ((_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.brandBlueHover);
});
var PillContent = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", "px;\n"])), function (props) {
  var _a;

  return (_a = props.theme.spacings) === null || _a === void 0 ? void 0 : _a.xxs;
});
var Text = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.darkest;
});
var Amount = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) {
  var _a;

  return (_a = props.theme.palette) === null || _a === void 0 ? void 0 : _a.placeholder;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
export { Amount, PillComponent, PillContent, Text };